<form *ngIf="addEditForm && validation" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate(dialogBoxBrand)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid Loyalty" >
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.code.nullable}">{{ validation.code.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input id="codeBrand" name="codeBrand" formControlName="code" type="text" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.code"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.name.nullable}">{{ validation.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input id="nameBrand" name="nameBrand" formControlName="name" type="text" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.name"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.logo.nullable}">{{ validation.logo.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input id="logoBrand" name="logoBrand" formControlName="logo" type="text" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.logo"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <br />
      <button id="addBrand" name="addBrand" class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{dialogBoxBrand.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'brandList.brand' |translate }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/brand/brandForm.html